import React, { useEffect, useState, useRef } from 'react';
import ver1 from "../../assets/HomePage/aboutus/v1.png";
import ver2 from "../../assets/HomePage/aboutus/v2.png";
import app1 from "../../assets/HomePage/aboutus/v3.png";
import app2 from "../../assets/HomePage/aboutus/v4.png";

const data = [
    { id: 1, title: "Web Version 0.1", subtitle: "April 14, 2025", image: ver1, content: "Get started with Koala Recognition AI 0.1." },
    { id: 2, title: "Web Version 0.2", subtitle: "April 28, 2025", image: ver2, content: "Powered by dozens of web components and interactive elements." },
    { id: 3, title: "Web Version 0.3", subtitle: "May 25, 2025", image: app1, content: "Join our growing community of koala lovers through our improved platform." },
    { id: 4, title: "App Version 0.1", subtitle: "May 31, 2025", image: app2, content: "Enjoy a more convenient photo uploading experience with our new app." }
];

export default function InfoLeaflet() {
    const [scrollY, setScrollY] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);
    const screenHeight = typeof window !== 'undefined' ? window.innerHeight : 800;
    const screenWidth = typeof window !== 'undefined' ? window.innerWidth : 1200;

    useEffect(() => {
        const handleScroll = () => {
            if (containerRef.current) {
                const offsetTop = containerRef.current.getBoundingClientRect().top + window.scrollY;
                const localScroll = window.scrollY - offsetTop;
                setScrollY(localScroll);
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Initialize on mount
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div ref={containerRef} className="relative" style={{ height: `${data.length * screenHeight}px` }}>
            <div className="sticky top-0 h-screen">
                <div className="relative w-full h-full">
                    {data.map((block, index) => {
                        const start = index * screenHeight;
                        let progress = (scrollY - start) / screenHeight;
                        progress = Math.max(0, Math.min(1, progress));
                        const translateX = -progress * screenWidth;

                        return (
                            <div
                                key={block.id}
                                className="absolute top-0 left-0 w-full h-full flex items-center justify-center transition-transform duration-300 ease-out"
                                style={{
                                    transform: `translateX(${translateX}px)`,
                                    zIndex: data.length - index,
                                }}
                            >
                                <div className="w-[90%] max-w-5xl h-[80%] md:h-[50%] 
                                border-l-8 border-primary bg-gradient-to-tr from-background to-white shadow-lg p-8 flex flex-col justify-center items-center rotate-[3deg]">
                                    <div className="grid grid-cols-1 md:grid-cols-12">
                                        <div className="md:col-span-5 flex items-center justify-center h-full">
                                            <img
                                                className='object-contain max-h-[250px] md:max-h-[350px] w-auto transition-transform duration-700 hover:scale-105'
                                                src={block.image}
                                                alt={block.title}
                                                loading="eager"
                                            />
                                        </div>
                                        <div className='md:col-span-1'></div>
                                        <div className='md:col-span-6 relative flex flex-col justify-center'>
                                            <div className='mb-3 text-sm font-bold text-primaryAlt/60'>{block.subtitle}</div>
                                            <h2 className="text-3xl md:text-5xl font-bold mb-4 text-primaryAlt">{block.title}</h2>
                                            <p className="text-base md:text-xl text-gray-400">
                                                {block.content}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div >
    );
}
